import { Button, Flex, LoadingOverlay } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconArrowLeft } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../../_base/extension/StringExtension";
import Repository from "../../../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../../../const/apiRoute";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblConfigGroup } from "../../../../model/TblConfigGroup";
import ConfigGroupProduct from "./ConfigGroupProduct";
import BreadCrumb from "../../../../_base/component/_layout/_breadcrumb";

const EditViewConfigGroupV2 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state && location.state.id;
  const [visible, { close, open }] = useDisclosure(false);
  const [data, setData] = useState<TblConfigGroup>();
  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

  const callApiGetData = async () => {
    open();
    let urlCreate = API_ROUTE.DETAIL_CONFIG_GROUP + id;
    let callapi =
      await repository.get<MessageResponse<TblConfigGroup>>(urlCreate);
    if (!isNullOrUndefined(callapi) && !isNullOrUndefined(callapi?.data)) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        setData(dataApi);
      }
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
    close();
  };

  useEffect(() => {
    callApiGetData();
  }, [id]);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{ padding: "20px 10px" }}
      >
        <BreadCrumb />
        <Button
          leftSection={<IconArrowLeft size={18} />}
          onClick={() => navigate(-1)}
          variant="light"
        >
          Quay lại
        </Button>
      </Flex>
      <div style={{ position: "relative" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <ConfigGroupProduct
          idGroup={id}
          initialName={data?.name || ""}
          initialDescription={data?.description || ""}
          dataConfigGroupProduct={data?.tblConfigGroupProductModels || []}
          dataConfigGroupAttribute={data?.tblConfigGroupAttributeModels || []}
          callApiGetData={callApiGetData}
        />
      </div>
    </>
  );
};

export default EditViewConfigGroupV2;
